import type { CheckoutCancellationGrant, CheckoutCancellationReason } from '../shared/checkout-cancellation.js';

export async function recordCheckoutCancellation(
  grant: CheckoutCancellationGrant,
  reason: CheckoutCancellationReason,
  fetchImpl: typeof fetch = fetch,
): Promise<boolean> {
  const {
    checkoutAttemptId,
    checkoutCancellationId,
    checkoutCancellationToken,
    checkoutCancellationExpiresAt,
  } = grant;
  if (!checkoutAttemptId || !checkoutCancellationId || !checkoutCancellationToken
    || checkoutCancellationExpiresAt === undefined) return false;
  try {
    const response = await fetchImpl('/api/stripe/cancel', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        checkout_attempt_id: checkoutAttemptId,
        checkout_cancellation_id: checkoutCancellationId,
        checkout_cancellation_token: checkoutCancellationToken,
        checkout_cancellation_expires_at: checkoutCancellationExpiresAt,
        reason,
      }),
      keepalive: true,
    });
    return response.ok;
  } catch {
    return false;
  }
}
